const SET_REFERENTIEL = 'SET_REFERENTIEL';
const SET_INFOS = 'SET_INFOS';

export {
	SET_REFERENTIEL,
	SET_INFOS
}